<template>
  <div class="row text-left">
    <div class="col-12">
      <div class="fields">
        <label class="caption1 color-secondary-600 bold mb-2"
          >Foto do perfil</label
        >
        <div class="d-flex">
          <img class="imgPreview" :src="urlPreviewImage" />
          <div class="image-upload d-flex flex-column ml-4">
            <label class="image-upload-inner" for="file-input">
              <img src="/static/novomundosenai/imgs/adicionar-foto.svg" />
            </label>
            <input id="file-input" type="file" @change="changedFile" />
            <label class="caption1 color-gray-300"
              >Formato jpg, png ou gif <br />Tamanho máximo de 5MB</label
            >
          </div>
        </div>
      </div>
      <div class="input-label">
        <label class="caption1 color-secondary-600 bold mb-2"
          >Qual seu nome?<span class="feedback-color-error">*</span></label
        >
        <input id="nome" type="text" placeholder="Nome completo" v-model="valueInternal.name" :class="{ 'border-error': v$.valueInternal.name.$error }"/>
      </div>
      <div class="input-label">
        <label class="caption1 color-secondary-600 bold mb-2" 
          >Título profissional</label
        >
        <input
          class="caption1"
          id="titulo"
          type="text"
          v-model="valueInternal.titleProfission"
          placeholder="Área de atuação, objetivo profissional e/ou cargo almejado. Ex.: Especialista em Marketing"
        />
      </div>
      <div class="d-flex">
        <div class="input-label">
          <label class="caption1 color-secondary-600 bold mb-2"
            >Qual seu Estado?</label
          >
          <select-component classNames="select-size-big" id="estado" valueKey="nome" placeholder="Estado" :value.sync="valueInternal.state" :valuesList="stateList"></select-component>
        </div>
        <div class="input-label ml-4 ml-md-32">
          <label class="caption1 color-secondary-600 bold mb-2"
            >Qual sua Cidade?</label
          >
          <select-component classNames="select-size-big" id="cidade" valueKey="nome" placeholder="Cidade" :value.sync="valueInternal.city" :valuesList="cityList"></select-component>
        </div>
      </div>
      <div class="d-flex flex-column flex-md-row">
        <div class="input-label">
          <label class="caption1 color-secondary-600 bold mb-2"
            >Qual seu e-mail<span class="feedback-color-error">*</span></label
          >
          <input
            :class="{ 'border-error': v$.valueInternal.email.$error }"
            class="input-size-big"
            id="email"
            type="text"
            placeholder="E-mail"
            v-model="valueInternal.email"
          />
        </div>
        <div class="input-label ml-md-32">
          <label class="caption1 color-secondary-600 bold mb-2"
            >Qual seu telefone<span class="feedback-color-error">*</span></label
          >
          <input
            :class="{ 'border-error': v$.valueInternal.cellphone.$error }"
            v-model="valueInternal.cellphone"
            type="tel"
            v-mask="['(##) ####-####', '(##) #####-####']"
            id="telefone"
            class="input-size-big"
            placeholder="(_) _____-____"
          />
        </div>
      </div>
      <div class="input-label">
        <label class="caption1 color-secondary-600 bold mb-2"
          >Fale sobre você</label
        >
        <p class="caption1 color-gray-400 mb-32">
          Impressione com uma introdução que resuma seus pontos fortes e
          <br class="d-none d-md-block" />experiências. Este conteúdo vai
          aparecer no topo de seu currículo.
        </p>
        <textarea
          id="desc"
          name="w3review"
          rows="6"
          cols="50"
          placeholder="Descrição pessoal"
          v-model="valueInternal.description"
        ></textarea>
      </div>
      <p class="caption2 float-right feedback-color-error">
        *campos obrigatórios
      </p>
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required, email, minLength } from '@vuelidate/validators'

import {mask} from 'vue-the-mask'
import SelectComponent from './shared/SelectComponent.vue';
import APIRegion from '../api/region'


export default {
  name: "DataInputComponent",
  directives: {mask},
  setup () {
    return { v$: useVuelidate() }
  },
  props: ['value', 'valid'],
  components: {
    SelectComponent
  },
  data() {
    return {
      stateList: [],
      cityList: []
    }
  },
  mounted() {
    this.loadStates();
    if(this.valueInternal.file) {
      this.valueInternal.urlPreview = URL.createObjectURL(this.valueInternal.file);
    }
  },
  validations () {
    return {
      valueInternal: {
        name: { required, $autoDirty: true },
        email: { required, email, $autoDirty: true },
        cellphone: { required, minLengthValue: minLength(14), $autoDirty: true },
      }
    }
  },
  watch: {
    'valueInternal.state'(val) {
      this.valueInternal.city = null;
      this.cityList = [];
      if (val) {
        this.loadCities(val);
      }
    },
    'v$.$invalid'(val) {
      this.validInternal = !val;
    }
  },
  computed: {
    urlPreviewImage() {
      if (this.valueInternal.file) {
        return this.valueInternal.file;
      }
      return '/static/novomundosenai/imgs/foto.svg';
    },
    valueInternal: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit("update:value", value);
      },
    },
    validInternal: {
      get: function () {
        return this.valid;
      },
      set: function (value) {
        this.$emit("update:valid", value);
      },
    },
  },
  methods: {
    loadStates() {
      const self = this;
      APIRegion.getStates().then(function(response) {
        self.stateList = response.data.results;
      })
      .catch(function(error) {
        alert(error.message)
      });
    },
    loadCities(state) {
      const self = this;
      APIRegion.getCities(state.id).then(function(response) {
        self.cityList = response.data.results;
      })
      .catch(function(error) {
        alert(error.message)
      });
    },
    changedFile(e) {
      const file = e.target.files[0];
      let reader = new FileReader();
      let self = this;
      reader.onload = (elFile) => {
        self.valueInternal.file = elFile.target.result
      }
      reader.readAsDataURL(file)
    }
  },
};
</script>

<style scoped>
.imgPreview {
  max-width: 128px;
}
</style>
